(function () {
  var HIDDEN = '!hidden';
  var modal;
  var player;
  var frame;
  var lastTrigger;

  function resolve() {
    modal = document.getElementById('video-modal');
    player = modal ? modal.querySelector('[data-video-modal-player]') : null;
    frame = modal ? modal.querySelector('[data-video-modal-embed]') : null;
    return !!player;
  }

  function reset() {
    player.pause();
    player.removeAttribute('src');
    player.removeAttribute('crossorigin');
    var track = player.querySelector('[data-video-modal-captions]');
    if (track) {
      track.track.mode = 'disabled';
      track.removeAttribute('src');
    }
    player.load();
    player.classList.remove(HIDDEN);
    if (frame) {
      frame.removeAttribute('src');
      frame.classList.add(HIDDEN);
    }
  }

  function close() {
    if (!modal || !modal.open) return;
    modal.close();
  }

  function open(src, label, embed, captions, language) {
    if (!resolve() || !src) return;
    if (label) modal.setAttribute('aria-label', label);

    if (embed && frame) {
      player.classList.add(HIDDEN);
      frame.classList.remove(HIDDEN);
      if (label) frame.setAttribute('title', label);
      frame.src = src;
      modal.showModal();
    } else {
      if (frame) frame.classList.add(HIDDEN);
      player.classList.remove(HIDDEN);
      var track = player.querySelector('[data-video-modal-captions]');
      if (track && captions) {
        player.crossOrigin = 'anonymous';
        track.srclang = language || 'en';
        track.label = language || 'en';
        track.src = captions;
        track.track.mode = 'showing';
      }
      player.src = src;
      modal.showModal();
      var playback = player.play();
      if (playback && typeof playback.catch === 'function') playback.catch(function () {});
    }

    document.documentElement.style.overflow = 'hidden';
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-video-modal-src]');
    if (trigger) {
      event.preventDefault();
      lastTrigger = trigger;
      open(
        trigger.getAttribute('data-video-modal-src'),
        trigger.getAttribute('data-video-modal-label'),
        trigger.hasAttribute('data-video-modal-embed'),
        trigger.getAttribute('data-video-modal-captions'),
        trigger.getAttribute('data-video-modal-captions-language')
      );
      return;
    }
    if (event.target.closest('[data-video-modal-close]')) {
      close();
      return;
    }
    if (modal && modal.open && (event.target === modal || event.target.hasAttribute('data-video-modal-surface'))) close();
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && modal && modal.open) close();
  }, true);

  document.addEventListener('close', function (event) {
    if (event.target !== modal) return;
    reset();
    document.documentElement.style.overflow = '';
    if (lastTrigger && document.contains(lastTrigger)) lastTrigger.focus();
    lastTrigger = null;
  }, true);
})();
